 export enum NetCode {
    SUCCESS = "1",
    TOKEN_EXPIRED = "403",
    BIZ_DISABLE = "10043",
    BIZ_MEMBER_DISABLE = "10044",
}
export enum SystemLanguageEnum {
    ZH = 'zh',
    EN = 'en',
    JA = 'ja',
    ZH_TW = 'zh-TW',
    KO = 'ko',
    HI = 'hi',
    DE = 'de',
    AR = 'ar',
    FR = 'fr',
    ID = 'id',
    ITB = 'itb',
    UK = 'uk',
}

export const Token = "pdf_token"

// subscribe dialog
export enum ActiveType{
    MEMBER = 'member',
    PACKAGE = 'package'
}
export enum TimeType{
    WEEK = 'week',
    MONTH = 'month',
    YEAR = 'year'
}